import { Env } from '@app/shared/utils/enums/environment.enum';
import { OktaAuthOptions } from '@okta/okta-auth-js';

export interface Environement {
  envName: Env;
  production: boolean;
  isStandalone: boolean;
  standaloneType?: StandaloneType;
  scriptEnv: string;
  bffApiUrl: string;
  productApiUrl: string;
  vetApiUrl: string;
  toolApiUrl: string;
  nutritionApiUrl: string;
  healthNutritionApiUrl: string;
  petOwnersApiUrl: string;
  coreApiUrl: string;
  myAccountUrl: string;
  ciam: {
    apiUrl: string;
    app: string;
    redirectCallback: string;
  };
  blobUrl: string;
  blobQueryParams: string;
  blobApiUrl: string;
  apimSubscriptionKey: string;
  appInsights: {
    instrumentationKey: string;
    role: string;
    roleInstance: string;
  };
  oktaConfig: OktaAuthOptions;
  marsFooterScript: string | null;
  oneTrustId: string;
  graphColor?: string;
  fgsUrl?: string;
}

export enum StandaloneType {
  VETMANAGER = 'vetmanager',
  GMVET = 'gmvet',
  MYVETE = 'myvete',
}
